/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseCrmSettings } from '../../models/api-response-crm-settings';
import { CrmSettings } from '../../models/crm-settings';

export interface UpdateSettings$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: CrmSettings
}

export function updateSettings(http: HttpClient, rootUrl: string, params: UpdateSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCrmSettings>> {
  const rb = new RequestBuilder(rootUrl, updateSettings.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseCrmSettings>;
    })
  );
}

updateSettings.PATH = '/v1/api/ui/zoho-crm/settings';
